import styled from '@emotion/styled';

import Accordion from 'components/global/Accordion';
import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const TitleContainer = styled.div`
	width: 100%;
	display: flex;
	padding: var(--padding-2);
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 1rem;
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 1rem;

	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}

	@media ${Breakpoints.tablet} {
		display: none;
	}
`;

export const FooterButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 1rem;

	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const FormContainer = styled(Card)`
	@media ${Breakpoints.tablet} {
		border-bottom: none !important;
		border-radius: 0 !important;
	}
	@media ${Breakpoints.mobile} {
		border-bottom: 1px solid var(--border-color) !important;
		border-radius: 0 !important;
	}
`;

export const AccordionFullWidth = styled(Accordion)`
	width: 100%;
`;
